import axios from "axios";

export default {
    namespaced: true,
    state: {
        active_organization_id: null,
    },
    mutations: {
        setActiveOrganization(state, organizationId) {
            state.active_organization_id = organizationId;
        },
    },
    getters: {
        // ...
    },
    actions: {
        loadOrganization({commit, rootState}, orgId){
            commit('setActiveOrganization', orgId);
        },
        loadStores({commit, rootState, state}){
            const ms_url = `${process.env.MIX_GATEWAY_URL}/store/v1/stores/list/all`;
            const ms_config = {headers: { "OrganizationId": state.active_organization_id }};

            return axios.get(ms_url, ms_config)
                .then((response) => response.data);
        },
        loadTerminals({commit, rootState, state}, storeId){
            const ms_url = `${process.env.MIX_GATEWAY_URL}/store/v1/stores/list/all`;
            const ms_config = {headers: { "OrganizationId": state.active_organization_id }};

            if (storeId) {
                return axios.get(ms_url, ms_config).then((response) =>
                    response.data
                        .find(store => store.id === storeId)
                        .terminals
                        .filter((terminal) => terminal.type === 'pointofsale')
                );
            } else {
                return axios.get(ms_url, ms_config).then((response) =>
                    response.data
                        .flatMap(store => store.terminals.map(terminal => ({...terminal, store: {id: store.id, name: store.name}})))
                );
            }
        },
        loadLicensedTerminals({commit, rootState, state}){
            return axios.get(`${rootState.appUrl}/customer/api/v3/ats3-licensed-terminals`).then((response) => {
                return response.data;
            });
        }
    },

};
